import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../components/layout/Header";
import Sidebar from "../../components/layout/Sidebar";
import { fetchItems } from "../../redux/actions/InventoryAction";
import { Container, Grid, Typography, Paper } from "@mui/material"; // Added MUI components
import Loader from "../../components/layout/Loader";

const ErpTutorialPage = ({ nav }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const { userInfo } = useSelector((state) => state.userSignIn);

  useEffect(() => {
    if (!userInfo) {
      navigate("/sign-in");
    }
    window.scrollTo(0, 0);
  }, [userInfo, navigate, dispatch]);

  // Sample iframe URLs for demo purposes
  const demoLinks = {
    orders: "https://www.youtube.com/embed/xd3R-36juQs?si=Dz2a4vupn9wwEJ8m",
    dealers: "https://www.youtube.com/embed/xd3R-36juQs?si=Dz2a4vupn9wwEJ8m",
    scheduling: "https://www.youtube.com/embed/xd3R-36juQs?si=Dz2a4vupn9wwEJ8m",
    accounting: "https://www.youtube.com/embed/xd3R-36juQs?si=Dz2a4vupn9wwEJ8m",
  };

  return (
    <>
      {userInfo && (
        <div className={nav.isSidebar}>
          <Header nav={nav} />
          <Sidebar nav={nav} />
          {/* Start content */}
          <main className="page-content">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0 p-0">
                <li className="breadcrumb-item active" aria-current="page">
                  ERP Tutorials
                </li>
                <li className="breadcrumb-item">
                  <Link to="/">
                    <i className="bx bx-home-alt" />
                  </Link>
                </li>
              </ol>
            </nav>

            <Container maxWidth="lg" sx={{ mt: 4 }}>
              <Typography variant="h4" gutterBottom>
                ERP System Overview
              </Typography>
              <Typography variant="body1" paragraph>
                Welcome to the ERP tutorial page. Here you will find a comprehensive, step-by-step guide
                to using various features of our ERP system, including order creation, dealer management, scheduling, 
                accounting, and more.
              </Typography>

              {/* Section for Orders */}
              <Paper elevation={3} sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ p: 2 }}>
                  <strong>Orders</strong>
                </Typography>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <iframe
                      width="100%"
                      height="315"
                      src={demoLinks.orders}
                      title="Order Management Tutorial"
                      frameBorder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body1" paragraph>
                      Learn how to create, update, and manage orders effectively in the ERP system. This tutorial
                      will guide you through the entire order management process step by step.
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>

              {/* Section for Dealers */}
              <Paper elevation={3} sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ p: 2 }}>
                  <strong>Dealers</strong>
                </Typography>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <iframe
                      width="100%"
                      height="315"
                      src={demoLinks.dealers}
                      title="Dealer Management Tutorial"
                      frameBorder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body1" paragraph>
                      Discover how to manage your dealers, including adding, updating, and tracking dealer information
                      in the system. This section provides all the tools you need for efficient dealer management.
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>

              {/* Section for Scheduling */}
              <Paper elevation={3} sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ p: 2 }}>
                  <strong>Scheduling</strong>
                </Typography>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <iframe
                      width="100%"
                      height="315"
                      src={demoLinks.scheduling}
                      title="Scheduling Tutorial"
                      frameBorder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body1" paragraph>
                      This section will guide you through the scheduling features of the ERP, enabling you to plan
                      and track all the production and installation schedules efficiently.
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>

              {/* Section for Accounting */}
              <Paper elevation={3} sx={{ mb: 3 }}>
                <Typography variant="h6" sx={{ p: 2 }}>
                  <strong>Accounting</strong>
                </Typography>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <iframe
                      width="100%"
                      height="315"
                      src={demoLinks.accounting}
                      title="Accounting Tutorial"
                      frameBorder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body1" paragraph>
                      Learn how to manage transactions, generate invoices, and handle accounting processes within
                      the ERP system. This tutorial covers the basics and more advanced accounting features.
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>

            </Container>
          </main>
        </div>
      )}
    </>
  );
};

export default ErpTutorialPage;
